// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Returns24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Returns24: FC<Returns24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="25"
        >
            <path d="M7 19.076v-2h7.1c1.05 0 1.963-.333 2.737-1 .776-.667 1.163-1.5 1.163-2.5s-.387-1.833-1.163-2.5c-.774-.667-1.687-1-2.737-1H7.8l2.6 2.6-1.4 1.4-5-5 5-5 1.4 1.4-2.6 2.6h6.3c1.617 0 3.004.525 4.162 1.575C19.421 10.7 20 12.009 20 13.576c0 1.567-.58 2.875-1.738 3.925-1.158 1.05-2.545 1.575-4.162 1.575H7Z" />
        </svg>
    );
};

export default Returns24;
